import s from './config.module.css';
import { LeadForm } from './lead-form/lead-form';
import { LeadPreview } from './lead-preview/lead-preview';
import { useLang } from '../../../../../hooks/use-lang';
import { Page } from '../../../../../components/page/page';

export const Config = () => {
  const { t } = useLang();

  return (
    <Page className={s.page}>
      <h2>{t('Конфигурация')}</h2>
      <div className={s.container}>
        <LeadForm />
        <LeadPreview />
      </div>
    </Page>
  );
};
